import { render } from "./ControlPanelMenu.vue?vue&type=template&id=28b30557&scoped=true"
import script from "./ControlPanelMenu.vue?vue&type=script&lang=js"
export * from "./ControlPanelMenu.vue?vue&type=script&lang=js"

import "./ControlPanelMenu.vue?vue&type=style&index=0&id=28b30557&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b30557"]])

export default __exports__